import React, { useEffect, useState } from 'react';
import { Link, useParams, useNavigate ,useLocation} from 'react-router-dom';
import { BiSolidLeftArrow, BiX } from 'react-icons/bi';


import Header from "../components/Header";
import Step from "../components/Step";
import SideInfo from "../components/SideInfo";

import data from '../json/palette.json'
import { sendAnalyticsData } from '../utilities/analytics';

const PageUnderTone2 = () => {


  let paletteData = [];

  const [palette, setPalette] = useState([]);
  const [dataImage, setDataImage] = useState(null);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [selectedColor, setSelectedColor] = useState('gold')

  const navigate = useNavigate();
  const location = useLocation()
  const { type } = useParams();


  useEffect(() => {
    paletteData = data.palette2
    setPalette(paletteData);


    if(location.state===null){
      navigate('/')
      return
    }
    const imageCaptured =location.state.photo
  
    setDataImage(imageCaptured)
    sendAnalyticsData('View Page','UnderTone2')
  }, []);


  
  const changeBg = (color) => {
    setSelectedColor(color);
    setButtonDisabled(false);
  }

  const renderDataImage = () =>{
    if(dataImage){
      return (
        <>
          <SideInfo title={'Check your undertone 2/3'} description={'Choose a color that makes your skin brighter and softens the color around your dark circles & smile lines'}/>
          <div className='image-captured-wrapper image-captured-wrapper2'>
            <img className='image-captured' src={dataImage} alt="Captured" />
            <img className={`face-bg`} src='/images/face-bg.png' alt=''/>
            {selectedColor ?
              <img className='face-bg' src={`/images/undertone-2/face-bg-${selectedColor.replace('#', '')}.png`} alt=''/>
              :
              null
            }
            <p className='section-step'>Check your undertone color 2/3</p>
            <div className='camera-hint d-block d-desktop-none'>Choose a color that makes your skin brighter and<br/>softens the color around your dark circles &amp; smile lines</div>
          </div>

          <div className='camera-colorpalette-wrapper'>
            <div className='title-sidebox d-none d-desktop-block'>UNDER TONE</div>
            <div className='camera-color-wrapper'>
              {palette.map((color, index) => {
                let colorUrl=''
                if(color === 'gold'){
                  colorUrl = '/images/undertone-2/palette-gold.png';
                }else{
                  colorUrl = '/images/undertone-2/palette-silver.png';
                }
                return <div key={index} className={`undertone-palette ${selectedColor === color ? 'active' : ''}`} onClick={() => {changeBg(color)}} style={{backgroundImage: `url(${colorUrl})`}}></div>
              })}
            </div>
            <Link className={`btn btn-primary d-none d-desktop-table mx-auto mt-4 w-100 ${buttonDisabled ? 'disabled' : ''}`} onClick={()=>{sendAnalyticsData('Click','Go To Undertone3 Page')}} to={`/${type}/undertone-3`} state={{photo:location.state.photo,skintone:location.state.skintone,undertone1:location.state.undertone1,undertone2:selectedColor}}>Next</Link>
          </div>
          <Link className={`btn-next btn btn-primary d-table d-desktop-none mx-auto w-100 ${buttonDisabled ? 'disabled' : ''}`} onClick={()=>{sendAnalyticsData('Click','Go To Undertone3 Page')}} to={`/${type}/undertone-3`} state={{photo:location.state.photo,skintone:location.state.skintone,undertone1:location.state.undertone1,undertone2:selectedColor}}>Next</Link>
        </>
      )
    }else{
      return <p className='text-center'>Photo not found</p>
    }
  }

  return (
    <div className='full-height'>
      <Header title={'UNDERTONE'} className='d-flex d-desktop-none'/>
      {type === 'basic' ?
        <Step activeLength={[3, 4]}/>
      :
        <Step activeLength={[3, 7]}/>
      }
      <div className='camera-palette-wrapper d-flex flex-column'>
        <div className='navigation'>
          <Link className='back' onClick={() => navigate(-1)} state={{state:location.state}}>
            <BiSolidLeftArrow/>
          </Link>
          <Link to='/'>
            <BiX/>
          </Link>
        </div>
        {renderDataImage()}
      </div>
      <Header className='d-none d-desktop-flex'/>
      <img className='petal-result-bg' src='/images/petal-page-2.png' alt=''/>
    </div>
  );
};

export default PageUnderTone2;
